import type { Submission } from '../../lib/types'
import { count, pct } from '../../lib/stats'

interface Props { data: Submission[]; generatedAt: string }

export function Overview({ data, generatedAt }: Props) {
  const N = data.length
  const flagCount  = count(data, d => !!d.has_red_flag)
  const tier3plus  = count(data, d => d.tier >= 3)
  const dismissed  = count(data, d => ['told-normal', 'told-lose-weight'].includes(d.medical_response ?? ''))
  const totalPanels = data.reduce((s, d) => s + d.investigation_gap.length, 0)
  const now = new Date(generatedAt)

  return (
    <header className="rh" id="overview">
      <div className="rh-eyebrow">FEMM Health Assessment · IFSD Network · Population Cohort Report</div>
      <h1 className="rh-title">Hormonal Health <em>Cohort Analysis</em></h1>
      <p className="rh-sub">
        Live · {now.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })} · n = {N}
      </p>
      <div className="rh-kpis">
        <div><div className="rh-kv">{N}</div><div className="rh-kl">Respondents</div></div>
        <div className="rh-sep" />
        <div><div className="rh-kv">{pct(tier3plus, N)}%</div><div className="rh-kl">Tier 3–4 (Concern+)</div></div>
        <div className="rh-sep" />
        <div><div className="rh-kv">{pct(dismissed, N)}%</div><div className="rh-kl">Medically dismissed</div></div>
        <div className="rh-sep" />
        <div><div className="rh-kv">{flagCount}</div><div className="rh-kl">Red flags</div></div>
        <div className="rh-sep" />
        <div><div className="rh-kv">{totalPanels}</div><div className="rh-kl">Panels unfilled (total)</div></div>
      </div>
    </header>
  )
}
